// extracted by mini-css-extract-plugin
module.exports = {"layout":"main_layout__2cfNk","content":"main_content__2Y6pH"};